import Vue from "vue";
import Vuex from "vuex";
import clocks from "../../models/relojes/clocks";
import service from '../../services/centrosDeCostos/clocks'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: '10px',
    clocks: [],
    liquidations: [],
    open: false,
    mode: 'Agregar centro de Costos',
    new: {},
    edit: {},
    itemDelete: null,
    openDelete: false
  },

  mutations: {
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setClocks(state, data) {
      state.clocks = data;
    },
    setOpen(state, data) {
      state.open = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setEdit(state, data) {
      state.edit = data;
    }
  },
  actions: {
    async getClocks(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getClocks();
          state.commit("setClocks", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getConceptId({ state, commit }, conceptoId) {
      try {
        const data = await state.service.getConceptoId(conceptoId);
        commit("setEditConcept", data);
        return true; 
      } catch (error) {
        throw error;
      }
    },

    async getLiquidationModels(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getLiqModelos();
          state.commit("setLiquidations", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getSalaries(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSueldos();
          state.commit("setSalaries", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async add(state) {
      try {
        const response = await state.state.service.addCostCenter(state.state.new);
        const newItem = concepts.fromJson(response.data);
        const updated = [newItem, ...state.state.costCenters];
        state.commit('setCostCenters', updated);
        return true;
      } catch (error) {
        return false;
      }
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.deleteCostCenter(state.state.itemDelete).then(() => {

            let options = state.state.concepts
            options = options.filter(option => {
              return option.id != state.state.itemDelete
            })
            state.commit('setCostCenters', options)
            resolve(true)
          });
        } catch (error) {
          reject(error)

        }
      })
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.editCostCenter(state.state.edit).then(() => {
            let item = state.state.edit;
            let options = state.state.costCenters
            options = options.map((option) => {
              if (option.id !== item.id) {
                return option
              }
              item = costCenters.fromJson({
                conceptoId: item.id,
                nombre: item.name,
                cat: item.cat,
                ws: item.ws 
              });
              return item
            });

            state.commit('setCostCenters', options)
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },



  },
});
